var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-narrow-bottom-alignment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8 12.5L12 16.5M12 16.5L16 12.5M12 16.5V4.5M4 20.5H20",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadO);
export default __webpack_public_path__ + "static/media/download-o.2c5b38d0536ac793951dd1347f5178c78c2cb081b51b6782cf2cccf2c2e91616.svg";
export { ForwardRef as ReactComponent };